module.exports = __webpack_public_path__ + "static/media/exaspaces.full.10d16793.png";